import { Navigate } from 'react-router-dom';
import { useTenant } from '../../context/TenantContext';
import FirstLoginPasswordModal from './FirstLoginPasswordModal';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { session, authLoading, mustChangePassword } = useTenant();

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-teal-600 flex items-center justify-center">
            <i className="ri-plane-line text-white text-xl" />
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="w-6 h-6 rounded-full border-2 border-teal-500 border-t-transparent animate-spin" />
            <p className="text-sm text-gray-400">Loading workspace...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {mustChangePassword && <FirstLoginPasswordModal />}
      {children}
    </>
  );
}
